const {
  ACTIVE_PROGRESS,
  DISABLE_PROGRESS,
} = require("redux/ActionTypes/ProgressActionTypes");

const initialState = {
  status: false,
};

const ProgressReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIVE_PROGRESS: {
      return {
        ...state,
        status: true,
      };
    }
    case DISABLE_PROGRESS: {
      return {
        ...state,
        status: false,
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default ProgressReducer;
